import { Tooltip } from 'antd'
import React from 'react'

const BadNumberTooltip = () => {
    // Direct container reference to override App.js configuration
  const getCustomContainer = () => document.body;
    return (
        <Tooltip 
        getPopupContainer={getCustomContainer}
        title={<span style={{ fontSize: "12px" }}
        
        >⚠️ Bad Phone Number</span>} >
            <span style={{ color: "red", fontSize: 12, cursor: "pointer", marginLeft: 10 }}>
                (BN)
            </span>
        </Tooltip>
    )
}

export default BadNumberTooltip


// WEBPACK FOOTER //
// ./src/Custom-Tooltip/BadNumberTooltip.js